import type { InvoiceStatus } from '../types.js'
import { invoiceBadgeVariant } from '../format.js'

const LABELS: Record<InvoiceStatus, string> = {
  unpaid: 'Unpaid',
  paid: 'Paid',
  overdue: 'Overdue',
  void: 'Void',
}

export function InvoiceBadge({ status }: { status: InvoiceStatus }) {
  return (
    <span className={`admin-badge admin-badge-${invoiceBadgeVariant(status)}`}>
      {LABELS[status]}
    </span>
  )
}
